<template>
    <div class="question-item">
        <div class="question-title">{{question.title}}</div>
        <div class="option-container">
            <div :class="{'question-option':true,'active': item.selected}" v-for="(item,index) in question.options"
                 :key="index">
                <div v-if="show" class="question-option-container ">
                    <div @click="selectHandler(item,index)" class="option-title ">
                        <div :class="{active: item.selected,'optionTitle': true}">{{item.label}}</div>
                        <i style="cursor: pointer" v-if="!item.selected" class="iconfont iconselect-normal"></i>
                        <i style="cursor: pointer" v-else class="iconfont iconselect-active"></i>
                    </div>
                </div>
                <div v-if="item.selected && question.input" class="input-container">
                    <input @input="inputChangeHandler(item,index)" type="text" v-model="item.input">
                </div>
                <div v-else-if="item.selected && item.input1" class="input-container">
                    <input @input="inputChangeHandler(item,index)" type="text" v-model="item.input">
                </div>
                <van-field v-if="item.selected && question.upload === '1'" name="uploader"
                           style="background-color: #F1F7FF">
                    <!--<van-field v-if="item.selected" name="uploader"-->
                    <!--style="background-color: #F1F7FF">-->
                    <template #input>
                        <van-uploader :preview-full-image="false" @delete="deleteHandler" multiple
                                      :after-read="afterRead" v-model="uploader"
                                      :max-count="5">
                            <!--<van-button  type="primary">上传文件</van-button>-->
                        </van-uploader>
                    </template>
                </van-field>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {ImagePreview} from 'vant';
    import {Uploader} from 'vant';
    import {Field} from 'vant';

    Vue.use(Field).use(Uploader);
    export default {
        name: 'question-single',
        props: {
            question: {required: true},
        },
        data() {
            return {
                step: 0,
                currentIndex: '',
                show: true,
                imageList: [],
                uploader: [],
                fileList: [],
            }
        },
        computed: {},
        watch: {
            // 'question.title': {
            //     handler(val, oldVal) {
            //         console.log(val, oldVal)
            //         if (oldVal && oldVal != val) {
            //             this.show = true
            //         }
            //     },
            //     immediate: true
            // },
            // 'question.answer': {
            //     handler(val) {
            //         if( val) {
            //             console.log('val',val);
            //             this.getAnswer()
            //         }
            //     },
            //     immediate: true
            // }
            // show: {
            //     handler(val) {
            //         if (val) {
            //             this.$nextTick(() => {
            //                 this.getAnswer()
            //             })
            //         }
            //     },
            //     immediate: true
            // }
        },
        mounted() {
            this.getAnswer()
        },
        methods: {
            getAnswer() {
                console.log('getAnswer', this.question);
                for(let k in this.question.options) {
                    if(this.question.options[k].input) {
                        this.question.options[k]['input1'] = 1
                    }
                }
                if (this.question.answer) {
                    let item = this.question.options[this.question.answer[0].choose]
                    this.selectHandler(item, this.question.answer[0].choose)
                        .then(() => {
                            this.$set(item, 'input', this.question.answer[0].input)
                            this.question.value[0].input = this.question.answer[0].input
                            this.$forceUpdate()
                        })
                }

            },
            selectHandler(item, index) {
                return new Promise(resolve => {
                    this.question.value = [{
                        choose: '',
                        input: '',
                        upload: {
                            type: 'pic',
                            url: "",
                            brief: "",
                        }
                    }]
                    if (this.currentIndex && this.currentIndex === index * 1) {
                        item.selected = false
                        this.currentIndex = null
                        this.uploader = []
                        this.imageList = []
                        return
                    }
                    for (var k in this.question.options) {
                        this.$set(this.question.options[k], 'selected', false)
                    }
                    this.$set(item, 'selected', true)
                    this.question.value[0].choose = index
                    item.input = ""
                    this.uploader = []
                    this.imageList = []
                    this.question.value[0].upload = {
                        type: 'pic',
                        url: "",
                        brief: "",
                    }
                    if (item.selected) {
                        this.currentIndex = index * 1
                    } else {
                        this.currentIndex = null
                        this.question.value = [{
                            choose: '',
                            input: '',
                            upload: {
                                type: 'pic',
                                url: "",
                                brief: "",
                            }
                        }]
                    }
                    resolve()
                })
            },
            inputChangeHandler(item, index) {
                this.question.value[0].input = item.input
            },
            deleteHandler() {
                this.imageList = []
                if (!this.uploader.length) {
                    this.question.options[this.currentIndex].uploadImage = ''
                    this.question.value[0].upload = {
                        type: 'pic',
                        url: "",
                        brief: "",
                    }
                } else {
                    this.afterRead(this.uploader)
                }
            },
            afterRead(file) {
                if (Object.prototype.toString.call(file) == '[object Array]') {
                    file.forEach(v => {
                        // v.status = 'uploading'
                        this.uploadImage(v.file)
                            .then((res) => {
                                this.imageList.push(res.url)
                                this.question.value[0].upload.url = this.imageList.join(',')
                            })
                            .catch(() => {
                                v.status = 'failed'
                            })
                    })
                } else {
                    // file.status = 'uploading'
                    this.uploadImage(file.file)
                        .then((res) => {
                            this.imageList.push(res.url)
                            this.question.value[0].upload.url = this.imageList.join(',')
                            // this.question.options[this.currentIndex - 1].uploadImage = this.imageList.join('##')
                            // file.status = 'done'
                            // this.$store.dispatch('getPicture',{url: [res.name]})
                            //     .then(res1 => {
                            //         //console.log('pic', res);
                            //         this.imageList.push(res1[0])
                            //         this.question.options[this.currentIndex - 1].uploadImage = this.imageList.join('##')
                            //         this.saveAnswer()
                            //     })
                        })
                }
            },
            uploadImage(file) {
                return new Promise((resolve, reject) => {
                    let uploadData = {}
                    uploadData.file = file
                    uploadData.url = file.name
                    uploadData.objName = `questionAnswerUrl/2021/${Math.floor(Math.random()) + new Date().getTime()}`
                    this.$store.dispatch('put', uploadData)
                        .then(res => {
                            if (res.res.status == 200) {
                                //console.log(res);
                                console.log(res);
                                resolve(res)
                            }
                        })
                        .catch((rej) => {
                            reject()
                        })
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import "questionCommon";

    .option-container {
        &.flex {
            display: flex;
            flex-wrap: wrap;
        }

        .question-option {
            &.two {
                width: 50%;
            }

            &.three {
                width: 30%;
            }

            .option-title {
                display: flex;
                /*align-items: center;*/
                width: 100%;
                .optionTitle {
                    cursor: pointer;
                    width: 100%;
                    text-align: left;
                    font-size: 16px;
                    word-wrap: break-word;
                    word-break: break-all;
                }
            }

            .option-other {
                width: 100%;

                .tips {
                    font-size: .12rem;
                    color: #ccc;
                }

            }
        }

        .input-container {
            text-align: left;

            input {
                width: 100%;
            }
        }
    }
</style>